import { useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../constants/urls';
import { notifyAuthChanged } from '../utils/dataLayer';

export default function useLogin() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const login = async ( email,password ) => {
    setLoading(true);
    setError(null);

    try {
        const response = await axios.post(`${BASE_URL}/auth/login`, {
            email,
            password
        }, 
        {
            headers: {
                Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
            },
        }
    );

      const { access_token } = response.data;
      localStorage.setItem('token', access_token);
      notifyAuthChanged();

      setLoading(false);
      return { token: access_token, error: null };
    } catch (err) {
      const message = err?.response?.data?.message || 'Erro no login, verifique suas credenciais!';
      setLoading(false);
      setError(message);
      return { token: null, error: message };
    }
  };

  return { login, loading, error };
}
